import CommonApp from '../app.js';

var BirthdayService = function($http, $q, $window) {
    this.$http = $http;
    var deferred = $q.defer();
};

BirthdayService.$inject = ['$http', '$q', '$window'];
CommonApp.module.service('birthdayServiceSrv', BirthdayService);



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/angular/services/birthday-srv.js
// module id = 277
// module chunks = 0